function RoomRevenueAccountCode() {
    return (
      <>
        <div className="font-bold text-lg mb-16">RoomRevenueAccountCode</div>
      </>
    );
  }
  
  export default RoomRevenueAccountCode;